export enum ReturnTypes {
  All = 0,
  Enable = 1,
  Disable = 2,
}

export function getReturnTypeName(value: ReturnTypes): string {
  switch (value) {
    case ReturnTypes.All: return 'すべて';
    case ReturnTypes.Enable: return '返信可';
    case ReturnTypes.Disable: return '返信不可';
  }
}
